import { Consultant, Franchise } from "@/types"
import api from "../client/axiosInstance"
import axios from "axios"

export const getFranchisees = async (params?: {
  page: number;
  limit: number;
}, withAi = false): Promise<{
  total: number;
  favoriteTotal: number;
  franchisees: Franchise[];
  favoriteFranchisees: Franchise[];
}> => {

  const endpoint = withAi
    ? "/users/ai-franchisees-search"
    : "/users"
  try {
    const response = await api.get(endpoint, {
      params,
    })
    return response.data
  } catch (error) {
    handleError(error, "Error fetching franchisors")
    return {
      total: 0,
      favoriteTotal: 0,
      franchisees: [],
      favoriteFranchisees: [],
    }
  }
}

export const addFavoriteFranchisor = async (
  id: string,
): Promise<Consultant | null> => {
  try {
    const response = await api.post(`users/favorite-franchisor`, {
      franchisorId: id,
    })
    return response.data
  } catch (error) {
    handleError(error, "Error adding favorite franchisor")
    return null
  }
}

export const getFranchiseeById = async (
  id: string,
): Promise<Franchise | null> => {
  try {
    const response = await api.get(`users/profile/${id}`)
    return response.data
  } catch (error) {
    handleError(error, "Error")
    return null
  }
}

export const getFilteredFranchisors = async (
  filter: string,
  withAi = false,
): Promise<{
  total: number;
  favoriteTotal: number;
  franchisees: Franchise[];
  favoriteFranchisees: Franchise[];
}> => {
  const endpoint = withAi
    ? `users/ai-franchisees-search?${filter}`
    : `users?${filter}`
  try {
    const response = await api.get(endpoint)
    return response.data
  } catch (error) {
    handleError(error, "Error fetching filtered consultants")
    return {
      total: 0,
      favoriteTotal: 0,
      franchisees: [],
      favoriteFranchisees: [],
    }
  }
}

export const getAdminFranchisorById = async (
  id: string,
): Promise<Franchise | null> => {
  try {
    const response = await api.get(`admin/users/${id}`)
    return response.data
  } catch (error) {
    handleError(error, "Error")
    return null
  }
}

export const getAdminConsultantById = async (
  id: string,
): Promise<Consultant | null> => {
  try {
    const response = await api.get(`admin/users/${id}`)
    return response.data
  } catch (error) {
    handleError(error, "Error")
    return null
  }
}

export const addFavoriteFranchise = async (
  id: string,
): Promise<Franchise | null> => {
  try {
    const response = await api.post(`users/favorite-franchisor`, {
      consultantId: id,
    })
    return response.data
  } catch (error) {
    handleError(error, "Error adding favorite consultant")
    return null
  }
}

const handleError = (error: unknown, message: string): never => {
  if (axios.isAxiosError(error)) {
    throw new Error(
      `${message}: ${error.response?.data?.message || error.message}`,
    )
  } else {
    throw new Error(`${message}: Unknown error occurred`)
  }
}
